<template>
    <rkm-area
        title="Parecer médico"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-radio-group
                    :disabled="desativaFormulario()"
                    :options="data.form.raat.agente"
                    :validations="validations.agente"
                    label="Agente"
                    textField="nome"
                    v-model="data.model.acidenteTrabalho.parecerMedico.agenteId"
                    valueField="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-group label="Partes do corpo atingidas">
                    <rkm-form-checkbox-group v-model="data.model.acidenteTrabalho.parecerMedico.partesCorpoAtingidas">
                        <rkm-row>
                            <rkm-col
                                v-for="item in data.form.raat.parteCorpoAtingida"
                                v-bind:key="item.id"
                                cols="3"
                            >
                                <rkm-form-checkbox
                                    :disabled="desativaFormulario()"
                                    :value="item.id"
                                    class="text-nowrap"
                                    inline
                                >
                                    {{ item.nome }}
                                </rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-form-checkbox-group>

                    <rkm-row
                        v-if="data.model.acidenteTrabalho.parecerMedico.partesCorpoAtingidas.find(item => item === enums.parteCorpoAtingida.OUTROS)"
                        class="mt-2"
                    >
                        <rkm-col>
                            <rkm-form-input
                                :disabled="desativaFormulario()"
                                :validations="validations.parteCorpoAtingidaOutras"
                                label="Outras"
                                v-model="data.model.acidenteTrabalho.parecerMedico.parteCorpoAtingidaOutras"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-form-group>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-group label="Causa do Acidente">
                    <rkm-form-checkbox-group v-model="data.model.acidenteTrabalho.parecerMedico.causasAcidente">
                        <rkm-row>
                            <rkm-col
                                v-for="item in data.form.raat.causaAcidente"
                                v-bind:key="item.id"
                                cols="3"
                            >
                                <rkm-form-checkbox
                                    :disabled="desativaFormulario()"
                                    :value="item.id"
                                    class="text-nowrap"
                                    inline
                                >
                                    {{ item.nome }}
                                </rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-form-checkbox-group>

                    <rkm-row
                        v-if="data.model.acidenteTrabalho.parecerMedico.causasAcidente.find(item => item === enums.causaAcidente.OUTROS)"
                        class="mt-2"
                    >
                        <rkm-col>
                            <rkm-form-input
                                :disabled="desativaFormulario()"
                                :validations="validations.causaAcidenteOutras"
                                label="Outros"
                                v-model="data.model.acidenteTrabalho.parecerMedico.causaAcidenteOutras"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-form-group>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-group label="Diagnóstico">
                    <rkm-form-checkbox-group v-model="data.model.acidenteTrabalho.parecerMedico.diagnosticos">
                        <rkm-row>
                            <rkm-col
                                v-for="item in formDiagnosticos()"
                                v-bind:key="item.id"
                                cols="3"
                            >
                                <rkm-form-checkbox
                                    :disabled="desativaFormulario()"
                                    :value="item.id"
                                    class="text-nowrap"
                                    inline
                                >
                                    {{ item.nome }}
                                </rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-form-checkbox-group>

                    <rkm-row
                        v-if="data.model.acidenteTrabalho.parecerMedico.diagnosticos.find(item => item === enums.diagnostico.OUTROS)"
                        class="mt-2"
                    >
                        <rkm-col>
                            <rkm-form-input
                                :disabled="desativaFormulario()"
                                :validations="validations.diagnosticoOutros"
                                label="Outros"
                                v-model="data.model.acidenteTrabalho.parecerMedico.diagnosticoOutros"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-form-group>
            </rkm-col>
        </rkm-row>

        <rkm-area
            title="SITUAÇÃO DO PACIENTE"
            type="fieldset"
            v-if="!formApenasRaat()"
        >

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-radio-group
                        v-model="data.model.acidenteTrabalho.parecerMedico.pacienteSofreuAcidenteTrabalho"
                        :disabled="desativaFormulario()"
                        label="Sofreu acidente de trabalho"
                        :options="radioOptionsGenericos"
                        text-field="key"
                        value-field="value"
                    />
                </rkm-col>
                <rkm-col cols="3">
                    <rkm-form-radio-group
                        v-model="data.model.acidenteTrabalho.parecerMedico.pacientePortadorDoencaOcupacional"
                        :disabled="desativaFormulario()"
                        label="Portador de doença ocupacional"
                        :options="radioOptionsGenericos"
                        text-field="key"
                        value-field="value"
                    />
                </rkm-col>
                <rkm-col cols="3">
                    <rkm-form-radio-group
                        v-model="data.model.acidenteTrabalho.parecerMedico.pacientePrecisaInternacao"
                        :disabled="desativaFormulario()"
                        label="Precisa de internação"
                        :options="radioOptionsGenericos"
                        text-field="key"
                        value-field="value"
                    />
                </rkm-col>
                <rkm-col cols="3">
                    <rkm-form-input
                        v-model="data.model.acidenteTrabalho.parecerMedico.diasAfastamento"
                        :disabled="desativaFormulario()"
                        label="Dias de afastamento"
                        type="number"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    label="CID 10"
                    disabled
                    :value="cid"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :disabled="desativaFormulario()"
                    :validations="validations.observacao"
                    label="Observação"
                    v-model="data.model.acidenteTrabalho.parecerMedico.observacao"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="8">
                <rkm-form-radio-group
                    label="Classificação Inicial"
                    v-model="data.model.acidenteTrabalho.parecerMedico.classificacaoInicialId"
                >
                    <rkm-row>
                        <rkm-col
                            v-for="(item, index) in data.form.raat.classificacaoInicial"
                            v-bind:key="index"
                            cols="auto"
                        >
                            <rkm-form-radio
                                :disabled="desativaFormulario()"
                                :value="item.id"
                                class="text-nowrap"
                            >
                                {{ item.nome }}
                            </rkm-form-radio>
                        </rkm-col>
                    </rkm-row>
                </rkm-form-radio-group>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-group label="Com afastamento">
                    <rkm-form-radio-group
                        :disabled="desativaFormulario()"
                        v-model="data.model.acidenteTrabalho.parecerMedico.afastado"
                    >
                        <rkm-form-radio :value="true">
                            Sim
                        </rkm-form-radio>

                        <rkm-form-radio :value="false">
                            Não
                        </rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-form-group>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Enums.
import causaAcidente from '@/enums/pronto-atendimento/raat/causaAcidente'
import diagnostico from '@/enums/pronto-atendimento/raat/diagnostico'
import parteCorpoAtingida from '@/enums/pronto-atendimento/raat/parteCorpoAtingida'
import tipoFormularioAcidenteTrabalho from '@/enums/pronto-atendimento/tipoFormularioAcidenteTrabalho'

export default {
    computed: {
        validations() {
            return {
                parteCorpoAtingidaOutras: {
                    required: true,
                    min: 3,
                    max: 150,
                },
                causaAcidenteOutras: {
                    required: true,
                    min: 3,
                    max: 150,
                },
                diagnosticoOutros: {
                    required: true,
                    min: 3,
                    max: 150,
                },
                observacao: {
                    min: 3,
                    max: 150,
                }
            }
        },
        cid() {

            if (!this.data.model.acidenteTrabalho.parecerMedico.cid.codigo || !this.data.model.acidenteTrabalho.parecerMedico.cid.nome) {

                return ''
            }

            return this.data.model.acidenteTrabalho.parecerMedico.cid.codigo + ' - ' + this.data.model.acidenteTrabalho.parecerMedico.cid.nome
        }
    },
    data: () => ({
        enums: { causaAcidente, diagnostico, parteCorpoAtingida, tipoFormularioAcidenteTrabalho },
        radioOptionsGenericos: [
            { key: "SIM", value: true },
            { key: "NÃO", value: false },
        ]
    }),
    methods: {
        formApenasRaat() {
            return this.data.model.acidenteTrabalho.tipoFormularioAcidenteTrabalho == this.enums.tipoFormularioAcidenteTrabalho.RAAT;
        },
        formDiagnosticos() {
            return this.data.form.raat.diagnostico;
        },
        desativaFormulario() {
            return this.disabled || (this.data.model.acidenteTrabalho.parecerMedico.lotacao.profissional.id && this.data.form.lotacao.profissional.id !== this.data.model.acidenteTrabalho.parecerMedico.lotacao.profissional.id)
        }
    },
    props: {
        data: { type: Object, required: true },
        disabled: { type: Boolean, default: false },
    },
}
</script>